import OrderHistoryContent from './OrderHistoryContent.jsx';
import OrderHistoryDetailContent from './OrderHistoryDetailContent';
import './_OrderHistoryContent.scss';

export {OrderHistoryContent, OrderHistoryDetailContent};



// WEBPACK FOOTER //
// ./components/users/sub-view/order-history-content/index.js